import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionTitle from "@/components/base/SectionTitle";
import { themeOf } from "@/utils/content";

export default function CategoryGate() {
  return (
    <section id="categories" className="w-full scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionTitle
          eyebrow="快速直达入口"
          title="五个领域，按图索骥不迷路"
          description="想吃什么类型的瓜，对应入口点一下就到。每个分类页都支持按最新、最热排序，还能继续搜索细分关键词。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((item) => {
            const theme = themeOf(item.slug);
            return (
              <Link
                key={item.slug}
                to={`/category/${item.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <span className={`block h-1.5 w-full ${theme.dot}`} />
                <div className="flex flex-1 flex-col p-5">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${theme.icon}`}>
                    <i className={item.icon} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.name}
                  </h3>
                  <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{item.tagline}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span>{item.count} 条内容</span>
                    <span className={`flex items-center gap-1 font-semibold ${theme.text}`}>
                      进入
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}